import { generatePath } from "react-router-dom";
import { parseUrl, stringifyUrl } from "query-string";
import { AddOnCodes, AddOnBaseCode } from "component-library";
import {
  PlanCodePeriod,
  PlanSelectorSearchParams,
} from "component-library/src/components/Organisms/Billing/types";
import { CheckoutType, CHECKOUT_FULL_PATH } from "config/common";

export function getCheckoutLink({
  checkoutType = CheckoutType.Renewal,
  planCode,
  addOns,
}: {
  checkoutType?: CheckoutType;
  planCode?: string;
  addOns?: AddOnCodes[] | AddOnBaseCode[];
} = {}) {
  const param = planCode?.includes(PlanCodePeriod.Annual)
    ? PlanCodePeriod.Annual
    : PlanCodePeriod.Monthly;

  const parsedUrl = parseUrl(
    generatePath(CHECKOUT_FULL_PATH, { type: checkoutType })
  );

  if (planCode) {
    parsedUrl.query[PlanSelectorSearchParams.PreSelectedPlan] = param;
  }

  if (addOns) {
    parsedUrl.query[PlanSelectorSearchParams.PreSelectedAddOns] = addOns.map(
      (addOn) => addOn
    );
  }

  return stringifyUrl(parsedUrl);
}
